// assets/clickable-discount.js
class ClickableDiscount extends HTMLElement {
  connectedCallback() {
    this.btn = this.querySelector('.clickable-discount__btn');
    if (this.btn) {
      this.btn.addEventListener('click', this.applyDiscount.bind(this));
    }

    // Check if already applied (cookie)
    const code = this.dataset.code;
    if (document.cookie.includes('discount_applied=' + code)) {
      this.setApplied();
    }
  }

  async applyDiscount() {
    if (this.dataset.applied === 'true' || this.dataset.loading === 'true') return;

    const code = this.dataset.code;
    this.dataset.loading = 'true';

    try {
      const res = await fetch('/discount/' + encodeURIComponent(code), {
        method: 'GET',
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });

      if (res.ok) {
        this.setApplied();
        // Store in cookie so it persists on page revisit
        document.cookie = 'discount_applied=' + code + '; path=/; max-age=86400';
      } else {
        this.setError();
      }
    } catch (e) {
      this.setError();
    } finally {
      this.dataset.loading = 'false';
    }
  }

  setApplied() {
    this.dataset.applied = 'true';
    const text1 = this.querySelector('.clickable-discount__btn__text-1');
    const text2 = this.querySelector('.clickable-discount__btn__text-2');
    if (text1) text1.style.display = 'none';
    if (text2) text2.style.display = 'block';
  }

  setError() {
    this.dataset.error = 'true';
    const errEl = this.closest('div')?.nextElementSibling;
    if (errEl?.classList.contains('clickable-discount__error')) {
      errEl.style.display = 'block';
    }
  }
}

customElements.define('clickable-discount', ClickableDiscount);
